import { RunnerCompetitionDto } from "../../../../../../../api/runner-competition";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import {
  RabbitFestivalCompetitionsItem,
  RabbitFestivalCompetitionsItemText,
  RabbitFestivalCompetitionsListWrapper,
} from "./style";

interface RabbitFestivalCompetitionsListProps {
  list: RunnerCompetitionDto[];
}

export const RabbitFestivalCompetitionsList = ({
  list,
}: RabbitFestivalCompetitionsListProps) => {
  const { handleCompetitionPage } = useRabbitFestivalContext();
  return (
    <RabbitFestivalCompetitionsListWrapper>
      {list.map((item, i) => (
        <RabbitFestivalCompetitionsItem
          key={i}
          onClick={() => handleCompetitionPage(item.id)}
        >
          <img src={item.bannerImage} alt="competition" />
          <div className="back" />
          <RabbitFestivalCompetitionsItemText>
            <div className="title">{item.title}</div>
            <div className="subTitle">{item.subTitle}</div>
          </RabbitFestivalCompetitionsItemText>
        </RabbitFestivalCompetitionsItem>
      ))}
    </RabbitFestivalCompetitionsListWrapper>
  );
};

export default RabbitFestivalCompetitionsList;
